import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import InspirationPhotoCard from 'components/consumer/inspiration-photos-card';
import RatioContainer from 'components/consumer/RatioContainer';
import ReviewComponent from 'components/consumer/PDP/PDPFabricDetailSidebar/PDPFabricReviews/ReviewComponent';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
const MixedGridCard = t0 => {
  const $ = _c(24);
  const {
    index,
    hits,
    hoveredValue,
    layout,
    onHoverHandler,
    toggleModalView,
    card_type,
    onClick,
    photo_id,
    customer_first_name,
    customer_last_name,
    image_link,
    photo_comment,
    products,
    date,
    full_name,
    location,
    rate,
    review,
    productData
  } = t0;
  if (card_type === "product" && productData) {
    let t1;
    if ($[0] !== layout || $[1] !== productData) {
      t1 = <ProductCardStatic {...productData} layout={layout} />;
      $[0] = layout;
      $[1] = productData;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (card_type === "customer_photo") {
    let t1;
    if ($[3] !== customer_first_name || $[4] !== customer_last_name || $[5] !== image_link || $[6] !== photo_comment || $[7] !== photo_id || $[8] !== products) {
      t1 = {
        photo_id,
        customer_first_name,
        customer_last_name,
        image_link,
        photo_comment,
        products
      };
      $[3] = customer_first_name;
      $[4] = customer_last_name;
      $[5] = image_link;
      $[6] = photo_comment;
      $[7] = photo_id;
      $[8] = products;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    let t2;
    if ($[10] !== hits || $[11] !== hoveredValue || $[12] !== index || $[13] !== onClick || $[14] !== onHoverHandler || $[15] !== t1 || $[16] !== toggleModalView) {
      t2 = <RatioContainer><InspirationPhotoCard hits={hits} hoveredValue={hoveredValue} index={index} onClick={onClick} onHoverHandler={onHoverHandler} photo={t1} toggleModalView={toggleModalView} /></RatioContainer>;
      $[10] = hits;
      $[11] = hoveredValue;
      $[12] = index;
      $[13] = onClick;
      $[14] = onHoverHandler;
      $[15] = t1;
      $[16] = toggleModalView;
      $[17] = t2;
    } else {
      t2 = $[17];
    }
    return t2;
  }
  if (card_type === "review") {
    let t1;
    if ($[18] !== date || $[19] !== full_name || $[20] !== location || $[21] !== rate || $[22] !== review) {
      t1 = <ReviewComponent collapsible={true} date={date} full_name={full_name} isInMixedGrid={true} location={location} maxWords={100} rate={rate} review={review} />;
      $[18] = date;
      $[19] = full_name;
      $[20] = location;
      $[21] = rate;
      $[22] = review;
      $[23] = t1;
    } else {
      t1 = $[23];
    }
    return t1;
  }
  return null;
};
MixedGridCard.propTypes = {
  cardSize: PropTypes.string,
  card_type: PropTypes.string,
  currentParentColors: PropTypes.arrayOf({}),
  customer_first_name: PropTypes.string,
  customer_last_name: PropTypes.string,
  date: PropTypes.string,
  disablePDPPrefetch: PropTypes.bool,
  full_name: PropTypes.string,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image_link: PropTypes.string,
  index: PropTypes.number,
  layout: PropTypes.string,
  location: PropTypes.string,
  onClick: PropTypes.func,
  onHoverHandler: PropTypes.func,
  photo_comment: PropTypes.string,
  photo_id: PropTypes.string,
  productData: PropTypes.object,
  products: PropTypes.array,
  toggleModalView: PropTypes.func,
  rate: PropTypes.number,
  review: PropTypes.string
};
export default MixedGridCard;